import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";

function SelectClientes(params) {
  const [datos, setDatos] = React.useState([]);
  const inputSelectClientes = useRef(null);
  useEffect(() => {
    getDatosClientes();
  }, [params.clientes]);

  function getDatosClientes() {
    let data = [];
    params.clientes.forEach((element) => {
      let opt = new OptionsAuto(element.cedula, element.nombreCompleto);
      data.push(opt);
    });
    setDatos(data);
  }

  function enfocarSelectClientes() {
    if (inputSelectClientes.current) {
      inputSelectClientes.current.focus();
    }
  }

  return (
    <div>
      <div
        style={{ marginLeft: "0.3em", padding: "0.3em" }}
        className="input-group"
      >
        <Autocomplete
          className="rounded"
          style={{ backgroundColor: "white" }}
          disablePortal
          id="combo-box-demo"
          value={params.value}
          sx={{ width: 260 }}
          renderInput={(params) => (
            <TextField
              id="autoCompleteTF"
              {...params}
              InputLabelProps={{ style: { color: "black" } }}
              size="small"
              inputRef={inputSelectClientes}
            />
          )}
          onChange={(_, newValue) => {
            params.getOnchange(newValue);
          }}
          inputValue={params.inputValue}
          onInputChange={(_, newInputValue) => {
            params.getInputChange(newInputValue);
          }}
          options={datos}
          freeSolo
        />
        <button
          style={{ display: "none" }}
          id="btnEnfocarSelect"
          onClick={enfocarSelectClientes}
        >
        </button>
      </div>
    </div>
  );
}

export default SelectClientes;

class OptionsAuto {
  constructor(id, label) {
    this.id = id;
    this.label = label;
  }

  getLabel() {
    return this.label;
  }

  getId() {
    return this.id;
  }
}
